/*! Starke Ceramic Coating Estimator — vanilla JS, embedded coverage data */
(function (global) {
  'use strict';

  var EMBEDDED_COVERAGE = {
  "version": 1,
  "help": "~100ml ≈ 650 sq ft (hull waterline-up + interior of a 24 ft boat). Estimates leave a little extra.",
  "phone": "800-203-5315",
  "phoneDisplay": "800-203-5315",
  "bottleMl": 100,
  "defaultProduct": "thor",
  "products": {
    "thor": {
      "handle": "liquid-thor-nano-ceramic-marine-coating",
      "url": "https://starkeyachtcare.com/products/liquid-thor-nano-ceramic-marine-coating"
    },
    "repel": {
      "handle": "reel-shine-starke-repel-pro-marine-grade-ceramic-coating",
      "url": "https://starkeyachtcare.com/products/reel-shine-starke-repel-pro-marine-grade-ceramic-coating"
    },
    "kraken": {
      "handle": "starke-liquid-kraken-marine-grade-graphene-nano-coating",
      "url": "https://starkeyachtcare.com/products/starke-liquid-kraken-marine-grade-graphene-nano-coating"
    }
  },
  "boats": [
    {
      "id": "center-console-true",
      "label": "Center Console (True)",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 200 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 400 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 300 },
            { "id": "all", "label": "All", "ml": 600 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "center-console-cabin",
      "label": "Center Console (Cabin)",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 200 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 400 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 300 },
            { "id": "all", "label": "All", "ml": 600 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "catamaran-motor",
      "label": "Catamaran (Motor)",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 400 },
            { "id": "all", "label": "All", "ml": 600 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 600 },
            { "id": "all", "label": "All", "ml": 900 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "catamaran-sailing",
      "label": "Catamaran (Sailing)",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "result": "verbal"
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "result": "verbal"
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "bowrider",
      "label": "Bowrider",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 200 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 400 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 300 },
            { "id": "all", "label": "All", "ml": 600 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "picnic",
      "label": "Picnic",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 500 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 400 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 300 },
            { "id": "all", "label": "All", "ml": 700 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "sportfish",
      "label": "Sportfish",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 500 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 400 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 300 },
            { "id": "all", "label": "All", "ml": 700 }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "wakeboard",
      "label": "Wakeboard",
      "skipLength": true,
      "coverages": [
        { "id": "top-or-bottom", "label": "Just the top or just the bottom", "ml": 100 },
        { "id": "both", "label": "Both top and bottom", "ml": 200 }
      ]
    },
    {
      "id": "sailing-cruiser",
      "label": "Sailing Cruiser",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": "verbal" },
            { "id": "all", "label": "All", "ml": 200 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "result": "verbal"
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "sailing-yacht",
      "label": "Sailing Yacht",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 500 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "result": "verbal"
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "trawler",
      "label": "Trawler",
      "skipLength": false,
      "lengths": [
        {
          "id": "0-24",
          "label": "0–24 ft (0–7 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 200 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
            { "id": "all", "label": "All", "ml": 300 }
          ]
        },
        {
          "id": "25-35",
          "label": "25–35 ft (7–11 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 200 },
            { "id": "all", "label": "All", "ml": 500 }
          ]
        },
        {
          "id": "36-45",
          "label": "36–45 ft (11–14 m)",
          "coverages": [
            { "id": "hull", "label": "Hull — waterline up", "ml": 400 },
            { "id": "hull-inside", "label": "Hull — waterline up (inside only)", "ml": 300 },
            { "id": "topside", "label": "Topside — rubrail up", "ml": 700 },
            { "id": "all", "label": "All", "ml": "verbal" }
          ]
        },
        {
          "id": "45-plus",
          "label": "45+ ft (14+ m)",
          "result": "verbal"
        }
      ]
    },
    {
      "id": "tender",
      "label": "Tender",
      "skipLength": true,
      "coverages": [
        { "id": "hull", "label": "Hull — waterline up", "ml": 100 },
        { "id": "topside", "label": "Topside — rubrail up", "ml": 100 },
        { "id": "all", "label": "All", "ml": 200 }
      ]
    }
  ]
}
;

  var PRODUCT_HANDLES = {
    thor: 'liquid-thor-nano-ceramic-marine-coating',
    repel: 'reel-shine-starke-repel-pro-marine-grade-ceramic-coating',
    kraken: 'starke-liquid-kraken-marine-grade-graphene-nano-coating'
  };

  function qs(name) {
    try {
      var p = new URLSearchParams(global.location.search);
      return (p.get(name) || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function resolveProduct(data, opt) {
    var key = (opt && opt.product) || qs('product') || (data && data.defaultProduct) || 'thor';
    if (PRODUCT_HANDLES[key]) return key;
    // allow full handle
    for (var k in PRODUCT_HANDLES) {
      if (PRODUCT_HANDLES[k] === key) return k;
    }
    return 'thor';
  }

  function productUrl(data, key) {
    if (data.products && data.products[key] && data.products[key].url) {
      return data.products[key].url;
    }
    return 'https://starkeyachtcare.com/products/' + (PRODUCT_HANDLES[key] || PRODUCT_HANDLES.thor);
  }

  /** Dedicated order page — Order now deep-link with recommended bottle qty. */
  function orderPageUrl(data, key, bottleCount) {
    var base = (data && data.orderPageUrl) || '/pages/coating-estimator-order';
    var q = '?product=' + encodeURIComponent(key || 'thor');
    var n = parseInt(bottleCount, 10);
    if (n > 0) q += '&qty=' + encodeURIComponent(String(n));
    return base + q;
  }

  function bottles(ml, bottleMl) {
    var unit = bottleMl || 100;
    return Math.ceil(Number(ml) / unit);
  }

  function findBoat(data, id) {
    for (var i = 0; i < data.boats.length; i++) {
      if (data.boats[i].id === id) return data.boats[i];
    }
    return null;
  }

  function findLength(boat, id) {
    if (!boat || !boat.lengths) return null;
    for (var i = 0; i < boat.lengths.length; i++) {
      if (boat.lengths[i].id === id) return boat.lengths[i];
    }
    return null;
  }

  function findCoverage(list, id) {
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  /** Lookup used by tests and runtime */
  function estimate(data, boatId, lengthId, coverageId) {
    var boat = findBoat(data, boatId);
    if (!boat) return { error: 'unknown boat' };

    if (boat.skipLength) {
      var c0 = findCoverage(boat.coverages, coverageId);
      if (!c0) return { error: 'unknown coverage' };
      if (c0.ml === 'verbal' || c0.ml == null) return { verbal: true };
      return { ml: c0.ml, bottles: bottles(c0.ml, data.bottleMl) };
    }

    var len = findLength(boat, lengthId);
    if (!len) return { error: 'unknown length' };
    if (len.result === 'verbal') return { verbal: true };

    var c = findCoverage(len.coverages, coverageId);
    if (!c) return { error: 'unknown coverage' };
    if (c.ml === 'verbal' || c.ml == null) return { verbal: true };
    return { ml: c.ml, bottles: bottles(c.ml, data.bottleMl) };
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function StarkeEstimator(root, options) {
    this.root = typeof root === 'string' ? document.querySelector(root) : root;
    this.options = options || {};
    this.data = null;
    this.state = { boatId: null, lengthId: null, coverageId: null, step: 'boat' };
    if (!this.root) return;
    this.root.classList.add('se-root');
    this.root.setAttribute('role', 'region');
    this.root.setAttribute('aria-label', 'Ceramic coating estimator');
    this._load();
  }

  StarkeEstimator.prototype._load = function () {
    var self = this;
    var src = this.options.dataUrl || this.root.getAttribute('data-coverage-url');
    if (src) {
      fetch(src)
        .then(function (r) { return r.json(); })
        .then(function (d) { self.data = d; self._render(); })
        .catch(function () {
          self.data = EMBEDDED_COVERAGE;
          self._render();
        });
    } else {
      this.data = this.options.data || EMBEDDED_COVERAGE;
      this._render();
    }
  };

  StarkeEstimator.prototype._productKey = function () {
    return resolveProduct(this.data, this.options);
  };

  StarkeEstimator.prototype._totalSteps = function () {
    var boat = findBoat(this.data, this.state.boatId);
    if (!boat) return 3; // boat + length + coverage (optimistic)
    if (boat.skipLength) return 2; // boat + coverage
    return 3; // boat + length + coverage
  };

  StarkeEstimator.prototype._stepIndex = function () {
    var boat = findBoat(this.data, this.state.boatId);
    if (this.state.step === 'boat') return 1;
    if (this.state.step === 'length') return 2;
    if (this.state.step === 'coverage') {
      return boat && boat.skipLength ? 2 : 3;
    }
    if (this.state.step === 'result') {
      return boat && boat.skipLength ? 2 : 3;
    }
    return 1;
  };

  StarkeEstimator.prototype._render = function () {
    var root = this.root;
    root.innerHTML = '';
    var wrap = el('div', 'se-wrap');
    var header = el('div', 'se-header');
    header.appendChild(el('h2', 'se-title', 'Ceramic Coating Estimator'));
    var prog = el('p', 'se-progress', '');
    if (this.state.step !== 'result') {
      prog.textContent = 'Step ' + this._stepIndex() + ' of ' + this._totalSteps();
    } else {
      prog.textContent = 'Your estimate';
    }
    header.appendChild(prog);
    wrap.appendChild(header);

    var body = el('div', 'se-body');
    if (this.state.step === 'boat') this._renderBoat(body);
    else if (this.state.step === 'length') this._renderLength(body);
    else if (this.state.step === 'coverage') this._renderCoverage(body);
    else if (this.state.step === 'result') this._renderResult(body);
    wrap.appendChild(body);

    if (this.state.step !== 'boat') {
      var nav = el('div', 'se-nav');
      var back = el('button', 'se-btn se-btn-ghost', 'Back');
      back.type = 'button';
      var self = this;
      back.addEventListener('click', function () { self._back(); });
      nav.appendChild(back);
      wrap.appendChild(nav);
    }

    var help = el('p', 'se-help', this.data.help || '');
    wrap.appendChild(help);
    root.appendChild(wrap);
  };

  StarkeEstimator.prototype._choices = function (body, title, items, onPick) {
    body.appendChild(el('h3', 'se-question', title));
    var list = el('div', 'se-choices');
    list.setAttribute('role', 'list');
    items.forEach(function (item) {
      var btn = el('button', 'se-choice', item.label);
      btn.type = 'button';
      btn.setAttribute('role', 'listitem');
      btn.addEventListener('click', function () { onPick(item); });
      list.appendChild(btn);
    });
    body.appendChild(list);
  };

  StarkeEstimator.prototype._renderBoat = function (body) {
    var self = this;
    this._choices(body, 'What type of boat do you have?', this.data.boats, function (boat) {
      self.state.boatId = boat.id;
      self.state.lengthId = null;
      self.state.coverageId = null;
      if (boat.skipLength) {
        self.state.step = 'coverage';
      } else {
        self.state.step = 'length';
      }
      self._render();
    });
  };

  StarkeEstimator.prototype._renderLength = function (body) {
    var self = this;
    var boat = findBoat(this.data, this.state.boatId);
    this._choices(body, 'What is the length of your boat?', boat.lengths, function (len) {
      self.state.lengthId = len.id;
      if (len.result === 'verbal') {
        self.state.step = 'result';
      } else {
        self.state.step = 'coverage';
      }
      self._render();
    });
  };

  StarkeEstimator.prototype._renderCoverage = function (body) {
    var self = this;
    var boat = findBoat(this.data, this.state.boatId);
    var list;
    var title = 'What would you like to coat?';
    if (boat.skipLength) {
      list = boat.coverages;
      if (boat.id === 'wakeboard') title = 'What would you like to coat?';
    } else {
      var len = findLength(boat, this.state.lengthId);
      list = len.coverages;
    }
    this._choices(body, title, list, function (cov) {
      self.state.coverageId = cov.id;
      self.state.step = 'result';
      self._render();
    });
  };

  StarkeEstimator.prototype._renderResult = function (body) {
    var data = this.data;
    var boat = findBoat(data, this.state.boatId);
    var result;
    if (boat.skipLength) {
      result = estimate(data, this.state.boatId, null, this.state.coverageId);
    } else {
      var len = findLength(boat, this.state.lengthId);
      if (len && len.result === 'verbal') {
        result = { verbal: true };
      } else {
        result = estimate(data, this.state.boatId, this.state.lengthId, this.state.coverageId);
      }
    }

    var card = el('div', 'se-result');
    if (result.verbal) {
      card.appendChild(el('p', 'se-result-label', 'Custom verbal estimate'));
      card.appendChild(el('p', 'se-result-copy', 'Boats this size or configuration need a quick call so we can size the job correctly.'));
      var phone = data.phone || '800-203-5315';
      var call = el('a', 'se-btn se-btn-primary', 'Call ' + (data.phoneDisplay || phone));
      call.href = 'tel:' + phone.replace(/[^0-9+]/g, '');
      card.appendChild(call);
    } else if (result.ml) {
      card.appendChild(el('p', 'se-result-label', 'Recommended amount'));
      card.appendChild(el('p', 'se-result-ml', result.ml + ' ml'));
      var b = result.bottles;
      var bottleText = b === 1 ? '1 bottle (100 ml)' : b + ' bottles (100 ml each)';
      card.appendChild(el('p', 'se-result-bottles', bottleText));
      var key = this._productKey();
      var order = el('a', 'se-btn se-btn-primary', 'Order now');
      order.href = orderPageUrl(data, key, b);
      order.rel = 'noopener';
      card.appendChild(order);
    } else {
      card.appendChild(el('p', 'se-result-copy', 'Unable to estimate. Please call us.'));
      var phone2 = data.phone || '800-203-5315';
      var call2 = el('a', 'se-btn se-btn-primary', 'Call ' + phone2);
      call2.href = 'tel:' + phone2.replace(/[^0-9+]/g, '');
      card.appendChild(call2);
    }

    var restart = el('button', 'se-btn se-btn-ghost se-restart', 'Start over');
    restart.type = 'button';
    var self = this;
    restart.addEventListener('click', function () {
      self.state = { boatId: null, lengthId: null, coverageId: null, step: 'boat' };
      self._render();
    });
    card.appendChild(restart);
    body.appendChild(card);
  };

  StarkeEstimator.prototype._back = function () {
    if (this.state.step === 'result') {
      var boat = findBoat(this.data, this.state.boatId);
      var len = boat && !boat.skipLength ? findLength(boat, this.state.lengthId) : null;
      if (len && len.result === 'verbal') {
        this.state.step = 'length';
        this.state.lengthId = null;
      } else {
        this.state.step = 'coverage';
        this.state.coverageId = null;
      }
    } else if (this.state.step === 'coverage') {
      var boat2 = findBoat(this.data, this.state.boatId);
      if (boat2 && boat2.skipLength) {
        this.state.step = 'boat';
        this.state.boatId = null;
      } else {
        this.state.step = 'length';
        this.state.lengthId = null;
      }
      this.state.coverageId = null;
    } else if (this.state.step === 'length') {
      this.state.step = 'boat';
      this.state.boatId = null;
      this.state.lengthId = null;
    }
    this._render();
  };

  function mountAll() {
    var nodes = document.querySelectorAll('[data-starke-estimator]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-se-mounted')) continue;
      nodes[i].setAttribute('data-se-mounted', '1');
      new StarkeEstimator(nodes[i], {
        product: nodes[i].getAttribute('data-product') || undefined,
        dataUrl: nodes[i].getAttribute('data-coverage-url') || undefined
      });
    }
  }

  global.StarkeEstimator = StarkeEstimator;
  global.StarkeEstimatorData = EMBEDDED_COVERAGE;
  global.StarkeEstimatorEstimate = function (boatId, lengthId, coverageId, data) {
    return estimate(data || EMBEDDED_COVERAGE, boatId, lengthId, coverageId);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})(typeof window !== 'undefined' ? window : this);
